import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 16 16"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M1.999 5.199a3.2 3.2 0 0 1 3.2-3.2H10.8a3.2 3.2 0 0 1 3.2 3.2v5.603a3.2 3.2 0 0 1-3.2 3.2H5.2a3.2 3.2 0 0 1-3.2-3.2zm1.485-.55h9.032A1.8 1.8 0 0 0 10.8 3.4H5.2a1.8 1.8 0 0 0-1.715 1.25m9.117 1.4H3.4v4.753a1.8 1.8 0 0 0 1.8 1.8h5.6a1.8 1.8 0 0 0 1.8-1.8z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            d="M6.1 10.617a.7.7 0 1 1-1.4 0 .7.7 0 0 1 1.4 0m2.555 0a.7.7 0 1 1-1.4 0 .7.7 0 0 1 1.4 0m0-2.555a.7.7 0 1 1-1.4 0 .7.7 0 0 1 1.4 0m2.555 0a.7.7 0 1 1-1.4 0 .7.7 0 0 1 1.4 0"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
